enum CommonAction {
  TestDriveBooking = 'testDriveBooking',
  OfferRequest = 'offerRequest',
  ShareLink = 'shareLink',
}

export default CommonAction;
